var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1821_41088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.842747 6.55421H15.1579C15.4943 6.55421 15.7971 6.36577 15.9317 6.08301C16.0663 5.80037 15.999 5.45485 15.7635 5.23497L11.659 1.24576C11.3394 0.931672 10.8179 0.915882 10.4815 1.21431C10.1451 1.51275 10.1282 1.99959 10.4479 2.31367L13.1898 4.98359L0.842786 4.9837C0.388574 4.9837 0.00170898 5.32922 0.00170898 5.76898C0.00170898 6.20874 0.371783 6.55426 0.842786 6.55426L0.842747 6.55421Z",
    fill: "#FDF41B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1407 9.45605H0.842431C0.50603 9.45605 0.203182 9.64449 0.0685801 9.92725C-0.0660073 10.2099 0.00134502 10.5554 0.236844 10.7753L4.32448 14.7645C4.49274 14.9216 4.71134 15 4.93005 15C5.13188 15 5.35059 14.9215 5.50196 14.7802C5.83836 14.4817 5.85527 13.9949 5.53563 13.6808L2.79369 11.0109H15.1407C15.5949 11.0109 15.9818 10.6654 15.9818 10.2256C15.9819 9.80165 15.6118 9.4561 15.1408 9.4561L15.1407 9.45605Z",
    fill: "#FDF41B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1821_41088"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.c47ad85a39ad80a32ffe3dd088d95327.svg";
export { ForwardRef as ReactComponent };